import React from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import './App.css';
import MainServices from "./components/MainService";

function App() {
  return (
   <Router>
      <div>
        <nav className="nav-bar">
          <NavLink to="/" className="nav-link" end>
            Home
          </NavLink>
          <NavLink to="/mainservices" className="nav-link">
            Services
          </NavLink>
          <NavLink to="/about" className="nav-link">
            About
          </NavLink>
          <NavLink to="/contact" className="nav-link">
            Contact Us
          </NavLink>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mainservices" element={<MainServices />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
